import { render, staticRenderFns } from "./YearComparisonTable.vue?vue&type=template&id=471bcf7b&"
import script from "./YearComparisonTable.vue?vue&type=script&lang=js&"
export * from "./YearComparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports